__webpack_require__.p = "https://cdn-b2c.dom.ru/b2c-domru/0.0.486/frontend/_next/";